<template>
  <div>
    <div @click="onClickPicker">
      <slot></slot>
    </div>

    <VanPopup
      v-model="showPicker"
      round
      safe-area-inset-bottom
      position="bottom"
      overlay-class="custom-van-popup-overlay"
      class="custom-van-popup"
    >
      <VanPicker
        ref="passengerPicker"
        :default-index="defaultIndex"
        show-toolbar
        value-key="label"
        :item-height="50"
        :columns="columns"
        :visible-item-count="5"
        class="custom-van-picker"
        @confirm="onConfirm"
      >
        <template #default>
          <div class="header">
            <div class="btn cancel" @click="onCancel">取消</div>
            <div class="title">选择乘坐车辆</div>
            <div class="btn confirm" @click="onClickConfirm">确定</div>
          </div>
        </template>
      </VanPicker>
    </VanPopup>
  </div>
</template>

<script>
export default {
  name: "BusSelector",
  model: {
    prop: "defaultIndex",
    event: "change",
  },
  props: {
    defaultIndex: {
      type: Number,
      default: 0,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showPicker: false,
    };
  },
  computed: {
    busLabel() {
      const item = this.columns[this.defaultIndex];
      if (!item) return "";
      return item.label;
    },
  },
  methods: {
    onClickPicker() {
      if (this.disabled) return;
      this.showPicker = true;
    },
    onClickConfirm() {
      const passengerPicker = this.$refs.passengerPicker;
      if (passengerPicker) {
        passengerPicker.confirm();
      }
    },
    onConfirm(value, index) {
      this.showPicker = false;
      this.$emit("change", index);
    },
    onCancel() {
      this.showPicker = false;
    },
  },
};
</script>

<style scoped lang="scss">
.row {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 42px;
}

.icon {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}
.label {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}

.arrow {
  width: 12px;
  height: 12px;
  margin-left: 4px;
}

.header {
  width: 100%;
  height: 80px;
  padding: 18px 20px;
  display: flex;
  justify-content: space-between;
}
.title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  text-align: center;
  font-style: normal;
}
.desc {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  line-height: 17px;
  text-align: center;
  font-style: normal;
  margin-top: 6px;
}

.btn {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: left;
  font-style: normal;
}

.cancel {
  color: #666666;
}

.confirm {
  color: #006efa;
  font-weight: 500;
}
</style>
